import React from 'react';
import ErrorView from './ErrorView';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        /* Update state so the next render will show the fallback UI. */
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        /* You can also log the error to an error reporting service */
    }

    render() {
        if (this.state.hasError) {
            /* Render fallback UI */
            return <ErrorView />;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
